import { Injectable } from '@angular/core';
import { Api, User } from '../'

@Injectable()
export class Tender {
  list: any;

  constructor(public api:Api, public user:User) { 

  }

  get(params?: any) {
    return this.api.get('index.php/marketing/tender', params);
  }

  post(params?: any) {
    if(params.id=='' || params.id==undefined){
      params.created_by = this.user.data.employee_id;
    }else{
      params.updated_by = this.user.data.employee_id;
    }
    return this.api.post('index.php/marketing/tender', params);
  }

  getTenderStat(params?: any) {
    return this.api.get('index.php/marketing/dashboard/tender_stat', params);
  }

  stat_per_dept(params?: any) {
    return this.api.get('index.php/marketing/dashboard/per_department', params);
  }

  getTenderApproval(params?: any){
    return this.api.get("index.php/marketing/tender/approval", params);
  }

  getPostTender(params?: any){
    return this.api.get("index.php/marketing/tender/postTender", params);
  }
  postPostTender(params?: any){
    if(params.id == '' || params.id == undefined){
      params.id == '';
      params.created_by = this.user.data.employee_id;
    }else{
      params.updated_by = this.user.data.employee_id;
    }
    return this.api.post("index.php/marketing/tender/postTender", params);
  }

}


// WEBPACK FOOTER //
// ./src/providers/marketing/tender/tender.ts